import {FC} from 'react';
import {APP} from "../Utils/Constants.ts";
interface PagerProps{
  nbrItem:number;
  value:Filter|undefined;
  handlePage: (filterId: string, value: any) => void;
}
const Pager: FC<PagerProps>= ({nbrItem, value, handlePage }) => {
    const currentPage = value ? parseInt(value.values) : 1;
    const toTop = () => {
      document.querySelector("#block-ifapme-theme-breadcrumbs")?.scrollIntoView();
    }
    let items: any = [];
    if (nbrItem > APP.NUMBER_PRODUCT_BY_PAGE) {
        items = items.concat([
            <li
                className="pager__item pager__item--previous"
                key="pager-previous">
                <button
                    title={"Aller à la page précédente"}
                    aria-label={"Aller à la page précédente"}
                    onClick={() => {
                        handlePage('page',currentPage - 1);
                        toTop();
                    }}
                    disabled={currentPage === 1}>
                    <i className="icon-angle-left"></i>
                </button>
            </li>
        ]);
        for (let i = currentPage - 3; i < currentPage + 2; i++) {
            if (i > -1 && ((i * APP.NUMBER_PRODUCT_BY_PAGE) < nbrItem)) {

                items.push(
                    <li
                        className={(i === currentPage - 1 ? "pager__item is-active" : "pager__item")}
                        key={"pager-" + i+1}>
                        <button

                            title={"Aller à la page n°" + (i + 1)}
                            aria-label={"Aller à la page n°" + (i + 1)}
                            onClick={() => {
                              handlePage('page',i+1);
                              toTop();
                            }}
                        > <span>{i + 1}</span></button>
                    </li>);
            }
        }
        items.push(
            <li
                className="pager__item pager__item--next"
                key="pager-next">
                <button
                    onClick={() => {
                      handlePage('page',currentPage + 1)
                      toTop();
                    }}
                    title={"Aller à la page suivante"}
                    aria-label={"Aller à la page suivante"}
                    disabled={((currentPage) * APP.NUMBER_PRODUCT_BY_PAGE >= nbrItem)}>
                    <i className="icon-angle-right"></i>
                </button>
            </li>);
    }


    return (
        <nav className={`pager`}>
            {items.length > 0 && <ul className="pager__items">{items}</ul>}
        </nav>
    );

}

export default Pager;
